<template>
  <div :style="scaleStyle" ref="previewMain" :class="{ 'is-sample': isSample, 'is-preview': !isSample }">
    <div class="doc-paper preview keirekisho" :id="idPrefix + 'preview-page-01'">
      <div class="keirekisho-wapper">
        <div class="keirekisho-header">
          <div class="date data text-right" :data-highlight="highlightMessage" @click="goCardTo('create-date')"
            :class="highLightClass('create-date')">
            <span v-html="formatedCreateDate"></span>
          </div>
          <br>
          <div class="data text-left" :data-highlight="highlightMessage" @click="goCardTo('company')"
            :class="highLightClass('company')">
            <span class="name" :style="formatData.selFontStyle" v-if="formatData.company_name">{{
              formatData.company_name }}</span>
            <span class="name" :style="formatData.selFontStyle" v-if="formatData.staff_name">{{ formatData.staff_name
              }}様</span>
          </div>
          <div class="data text-right" :data-highlight="highlightMessage" @click="goCardTo('letterprofile')"
            :class="highLightClass('letterprofile')">
            <div class="postal-code" :style="formatData.selFontStyle">&#12306;{{
              $formLib.separatedPostNumber(basicData.postNumber) }}</div>
            <pre :style="formatData.selFontStyle">{{ basicData.address1 }}
{{ basicData.address2 }}</pre>
            <span class="name" :style="formatData.selFontStyle">{{ basicData.tel1 }}-{{ basicData.tel2 }}-{{
              basicData.tel3 }}</span>
            <span class="name" :style="formatData.selFontStyle" v-if="basicData.email">{{ basicData.email }}</span>
            <span class="name" :style="formatData.selFontStyle">{{ basicData.lastName }}&emsp;{{ basicData.firstName
              }}</span>
          </div>
        </div>
        <br>
        <div class="data text-center">
          <span class="name">応募書類の送付につきまして</span>
        </div>
        <br>
        <div class="keirekisho-content">
          <div class="input" :data-highlight="highlightMessage" @click="goCardTo('intro')"
            :class="highLightClass('intro')">
            <pre ref="introSummary" :class="classObject.introSummary"
              :style="formatData.selFontStyle">{{ formatData.introSummary }}</pre>
          </div>
          <br>
          <div class="input" id="pr-message" :data-highlight="highlightMessage" @click="goCardTo('entry-detail')"
            :class="highLightClass('entry-detail')">
            <pre ref="entrySummary" :class="classObject.entrySummary"
              :style="formatData.selFontStyle">{{ formatData.entrySummary }}</pre>
          </div>
          <br>
          <div class="data text-right">
            <span class="name">敬具</span>
          </div>
          <br>
          <br>
          <br>
          <div class="data text-center" v-if="formatData.resumeSummary">
            <span class="name">記</span>
          </div>
          <div class="input text-left" v-if="formatData.resumeSummary" :data-highlight="highlightMessage"
            @click="goCardTo('resume-list')" :class="highLightClass('resume-list')">
            <pre ref="resumeSummary" :class="classObject.resumeSummary"
              :style="formatData.selFontStyle">{{ formatData.resumeSummary }}</pre>
          </div>
          <div class="data text-right" v-if="formatData.resumeSummary">
            <span class="name">以上</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LetterPreviewMixin from '@/mixins/letter-preview-mixin'
export default {
  name: 'letterPreview',
  mixins: [LetterPreviewMixin],
  data: function () {
    return {
      textareaMaxHeights: {
        introSummary: 90,
        resumeSummary: 90,
        entrySummary: 210
      }
    }
  },
  computed: {
  },
  methods: {
    checkValid: function () {
      this.adjustFontSize('introSummary')
      this.adjustFontSize('resumeSummary')
      this.adjustFontSize('entrySummary')
    }
  }
}
</script>
